/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPlanResponse
 */
export interface UserPlanResponse {
    /**
     * 
     * @type {string}
     * @memberof UserPlanResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPlanResponse
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof UserPlanResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserPlanResponse
     */
    billingInterval: string;
    /**
     * 
     * @type {number}
     * @memberof UserPlanResponse
     */
    priceCents: number;
    /**
     * 
     * @type {string}
     * @memberof UserPlanResponse
     */
    currency: string;
    /**
     * 
     * @type {Date}
     * @memberof UserPlanResponse
     */
    startsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UserPlanResponse
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserPlanResponse
     */
    source: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserPlanResponse
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPlanResponse
     */
    defaultPlan: boolean;
}

/**
 * Check if a given object implements the UserPlanResponse interface.
 */
export function instanceOfUserPlanResponse(value: object): value is UserPlanResponse {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('billingInterval' in value) || value['billingInterval'] === undefined) return false;
    if (!('priceCents' in value) || value['priceCents'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('defaultPlan' in value) || value['defaultPlan'] === undefined) return false;
    return true;
}

export function UserPlanResponseFromJSON(json: any): UserPlanResponse {
    return UserPlanResponseFromJSONTyped(json, false);
}

export function UserPlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPlanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'],
        'name': json['name'],
        'billingInterval': json['billingInterval'],
        'priceCents': json['priceCents'],
        'currency': json['currency'],
        'startsAt': json['startsAt'] == null ? undefined : (new Date(json['startsAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'source': json['source'],
        'active': json['active'],
        'defaultPlan': json['defaultPlan'],
    };
}

export function UserPlanResponseToJSON(json: any): UserPlanResponse {
    return UserPlanResponseToJSONTyped(json, false);
}

export function UserPlanResponseToJSONTyped(value?: UserPlanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'billingInterval': value['billingInterval'],
        'priceCents': value['priceCents'],
        'currency': value['currency'],
        'startsAt': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISOString(),
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'source': value['source'],
        'active': value['active'],
        'defaultPlan': value['defaultPlan'],
    };
}

